enum CommunityNavigationWidgetLinkType {
        url = 0,
        activities = 1,
        activitiesGroup = 2,
        activity = 3,
        todo = 4,
        logout = 5,
        moderatorTools = 6,
        observerTools = 7,
        communityProject = 8
}

export default CommunityNavigationWidgetLinkType;